import React from "react";
import BrowserViewGlobal from "../../Views/BrowserView";
import { Modal } from "react-bootstrap";
import EventUserItem from "../EventUserItem";
import EventDebounceInput from "./components/EventDebounceInput";
import EventQuestionsInput from "./components/EventQuestionsInput";
import EventVisitorList from "./components/EventVisitorList";
import EventInviteButton from "./components/EventInviteButton";
import UsersIcon from "../../Navigation/Icons/UsersIcon";

export default function EventUserBrowserView({
  handleModalTriggerClick,
  setShowModal,
  showModal,
  setSearchValue,
  eventQuestionData,
  renderTypeahead,
  handleInviteToPrivateChatroom,
  fetchEventUserLoadMore,
  getSelectedUsers,
  getFilteredSelectedValues,
  isLoading,
  eventUserList,
  eventUserCount,
  getSearchResultCount,
  handleChange,
  isInviting,
  isInvalidInvite,
  nextUrl,
  MAX_FORM_FIELDS,
  me,
  selectedValues,
  MAX_INVITES,
  hasProfilePicture,
}) {
  return (
    <BrowserViewGlobal>
      <button
        onClick={handleModalTriggerClick}
        className="nav_main__visitor_list"
      >
        <UsersIcon />
      </button>
      <Modal
        className="event-user-component-modal"
        size="md"
        //  scrollable
        backdrop="static"
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header closeButton closeVariant="white"> 
          <div className="modal-heading-area px-0 pb-md-3 pb-3 mt-1">
            <h5>New Message</h5>
            <form>
              <div className="gform-body mt-4">
                <div className="mb-3">
                  <EventDebounceInput setSearchValue={setSearchValue} />
                </div>
                <EventQuestionsInput
                  eventQuestionData={eventQuestionData}
                  MAX_FORM_FIELDS={MAX_FORM_FIELDS}
                  renderTypeahead={renderTypeahead}
                />
              </div>
              <EventInviteButton
                isInviting={isInviting}
                isInvalidInvite={isInvalidInvite}
                handleInviteToPrivateChatroom={handleInviteToPrivateChatroom}
                getSelectedUsers={getSelectedUsers}
              />
              <div className="user-wrapper__search-message">
                {eventUserCount && getSearchResultCount()} participants matched
                your search.
              </div>
            </form>
          </div>
        </Modal.Header>
        <Modal.Body className="pt-0" id="event-user-list">
          <EventVisitorList
            isLoading={isLoading}
            eventUserList={eventUserList}
            fetchEventUserLoadMore={fetchEventUserLoadMore}
            getFilteredSelectedValues={getFilteredSelectedValues}
            selectedValues={selectedValues}
            me={me}
            nextUrl={nextUrl}
            MAX_INVITES={MAX_INVITES}
            handleChange={handleChange}
            hasProfilePicture={hasProfilePicture}
            scrollableTarget={"event-user-list"}
          />
        </Modal.Body>
      </Modal>
    </BrowserViewGlobal>
  );
}
